import { Box, SidebarModal, Text } from '@domain-group/suit-theme'

import type { OrderItemModel } from '@models/types'

const OrderInstructions = (props: { orderItem: OrderItemModel }) => {
  const {
    orderItem: { additional_instructions },
  } = props

  if (!additional_instructions){
    return null
  }

  return (
    <SidebarModal.ExpandableSection
      label="Order Instuctions"
      style={{ marginTop: 16 }}
      title="View Additional Instruction"
    >
      <Box
        flexDirection="column"
        fontSize="small"
        paddingX="medium"
        paddingY="large"
        style={{ whiteSpace: 'pre-wrap' }}
        variant="whiteGrey"
      >
        <Text color="bodyFontColor">{additional_instructions}</Text>
      </Box>
    </SidebarModal.ExpandableSection>
  )
}

export default OrderInstructions
